import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('_fk__object_field__id', ['fkObjectFieldId'], {})
@Index(
	'_fk__rbac_role_object_action__id',
	['fkRbacActionObjectCrudId', 'fkObjectFieldId'],
	{ unique: true },
)
@Entity('_rbac_action__object__crud__attribute')
export class RbacActionObjectCrudAttributeEntity extends BaseEntity {
	@Column('int', { name: '_fk__rbac_action__object__crud__id', unsigned: true })
	public fkRbacActionObjectCrudId!: number;

	@Column('int', { name: '_fk__object_field__id', unsigned: true })
	public fkObjectFieldId!: number;

	@Column({ type: 'boolean', name: '_canHave', width: 1, nullable: false })
	public canHave!: boolean;
}
